'use strict';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 

class PageDistribution {

    constructor($target) {

        //Private properties
        $target;

        let distributionTitle = $target.find('.distribution_block__title');
        let distributionDescrWrap = $target.find('.distribution_block__description_wrap');
        // let distributionDescr = $target.find('.distribution_block__content_container p');
        // let distributionDivid = $target.find('.divider');
        let animWideScreen = window.matchMedia("(min-width:992px)");
        let onEnterTimeline = gsap.timeline({repeat: 0, repeatDelay: 0 });

        function init() {
            $(window).on('load', animateContentDistribution());
        }


        function animateContentDistribution(){

            if(animWideScreen.matches){
                
                // gsap.set([distributionTitle, distributionDescr, distributionDivid] , {opacity:0,  y: 20});
                 // onEnterTimeline.to([distributionTitle, distributionDescr, distributionDivid], {delay: 0.5, duration: 0.8, y: 0, opacity:1, stagger: 0.08})
                gsap.set([distributionTitle, distributionDescrWrap] , {opacity:0,  y: 80});
                onEnterTimeline.to([distributionTitle, distributionDescrWrap], {delay: -0.3, duration: 0.8, y: 0, opacity:1, stagger: 0.08})
               
            }
           
        }

       

        init();

        return {

         
            publicPageDistribution: function (string) {

            }

        }

    }

}

export default PageDistribution;